<div class="d-flex justify-content-between">
  <div class="card-sub-heading my-3">Total Medication Expense</div>
  <button mat-icon-button (click)="this.dialogRef.close()" type="button">
    <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
  </button>
</div>

<div class="pagination-table mt-3 overflow-auto" id="report_parameters">
  <table class="table" aria-describedby="Medication cost table">
    <thead>
      <tr>
        <th>Medication</th>
        <th>Cost</th>
        <th>Markup</th>
        <th>Fees</th>
        <th *ngIf="tenant == 'wylo'">Wylo Admin Charges</th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of props?.sale_order_rx_detail">
        <td>
          Rx-{{ item.RxNum }} {{ item.kroll_drg.BrandName }} ({{
            item.kroll_drg.GenericName
          }}) - {{ item.kroll_drg.Strength }}
        </td>
        <td>{{ item.Costs | number: ".1-2" }}</td>
        <td>{{ item.Markups | number: ".1-2" }}</td>
        <td>{{ item.Fees | number: ".1-2" }}</td>
        <td *ngIf="tenant == 'wylo'">{{ item.additional_cost ? (item.additional_cost | number: ".1-2") : 0 }}</td>
        <ng-container *ngIf="tenant == 'wylo'; else template">
          <td>
            {{ +item.Costs + +item.Markups + +item.Fees + +item.additional_cost | number: ".1-2" }}
          </td>
        </ng-container>
        <ng-template #template>
          <td>
            {{ +item.Costs + +item.Markups + +item.Fees | number: ".1-2" }}
          </td>
        </ng-template>
      </tr>
      <tr>
        <td>Delivery Cost</td>
        <td>0</td>
        <td></td>
        <td></td>
        <td *ngIf="tenant == 'wylo'"></td>
        <td class="d-flex align-items-center">
          <div>0</div>
        </td>
      </tr>
      <tr>
        <td class="bold">Total</td>
        <td></td>
        <td></td>
        <td></td>
        <td *ngIf="tenant == 'wylo'"></td>
        <td class="bold">{{ props?.TotalMedCost | number: ".1-2" }}</td>
      </tr>
    </tbody>
  </table>
</div>
<!-- TransType ko add krna ha -->
